import { default as filtration } from ":src/modules/grading/filtration/routes";
import { default as faq_inquiry } from ":src/modules/help-portal/faq-inquiry/routes";
import { default as profile } from ":src/modules/account/profile/routes";
export default {
  BASE: "/filterer",
  filtration,
  faq_inquiry,
  profile,
};
